"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _recompose = require("recompose");

var _reactRequiredIf = _interopRequireDefault(require("react-required-if"));

var _util = require("../../shared/util");

var _styles = require("./styles");

var _inputError = _interopRequireDefault(require("../input-error"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CheckboxWithError = function CheckboxWithError(_ref) {
  var className = _ref.className,
      hasError = _ref.hasError,
      errorMessage = _ref.errorMessage,
      textAlignRight = _ref.textAlignRight,
      rest = _objectWithoutProperties(_ref, ["className", "hasError", "errorMessage", "textAlignRight"]);

  return (0, _core.jsx)(_inputError.default, {
    hasError: hasError,
    errorMessage: errorMessage,
    className: className,
    textAlignRight: textAlignRight,
    forCheckbox: true
  }, (0, _core.jsx)(_styles.Checkbox, _extends({
    hasError: hasError
  }, rest)));
};

var _default = (0, _recompose.compose)((0, _recompose.defaultProps)({
  status: 'unchecked',
  labelPosition: 'after'
}), (0, _recompose.setPropTypes)({
  onChange: _propTypes.default.func.isRequired,
  status: _propTypes.default.oneOf(['checked', 'indeterminate', 'unchecked']).isRequired,
  id: _propTypes.default.string.isRequired,
  label: _propTypes.default.string.isRequired,
  disabled: _propTypes.default.bool,
  name: _propTypes.default.string,
  isRequired: _propTypes.default.bool,
  labelPosition: _propTypes.default.oneOf(['before', 'after', 'none']),
  hasError: _propTypes.default.bool,
  errorMessage: (0, _reactRequiredIf.default)(_propTypes.default.string, function (props) {
    return props.hasError;
  })
}), (0, _recompose.withHandlers)({
  hiddenInputOnChange: function hiddenInputOnChange(_ref2) {
    var onChange = _ref2.onChange;
    return function (e) {
      onChange(e);
    };
  }
}), (0, _recompose.withProps)(function (_ref3) {
  var id = _ref3.id,
      name = _ref3.name,
      labelPosition = _ref3.labelPosition,
      disabled = _ref3.disabled;
  return {
    name: name || id,
    textAlignRight: labelPosition === 'before',
    disableLabelColor: disabled
  };
}), (0, _recompose.setDisplayName)('Checkbox'))((0, _util.omitProps)(['onChange'])(CheckboxWithError));

exports.default = _default;